import { render, staticRenderFns } from "./EcertIndex.vue?vue&type=template&id=5be06991"
import script from "./EcertIndex.vue?vue&type=script&lang=js"
export * from "./EcertIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports